module.exports = __webpack_public_path__ + "static/media/user.be3162cc.svg";